import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

export default function ChoiceAnswer({ question, responseHandler, validateField, error }) {
    const q = question;
    const id = question.questionID;

    const [value, setValue] = React.useState(q.response.questionnaireAnswerID === null ? '' : `${q.response.questionnaireAnswerID}`);

    function handleClick(event) {
        let toVal;
        /*
         To support certain validations,
           this is three-state control that supports deselection:
            Yes (1)
            No (0)
            Unanswered (null)
        */
        if (event.target.value === value) {
            setValue((toVal = ''));
        } else {
            setValue((toVal = event.target.value));
        }
        responseHandler(id, toVal.length ? toVal : null, event);
        validateField();
    }

    return (
        <div>
            <FormControl key={`a${id}Choice`}>
                <FormLabel error={error}>
                    <p>{question.question}</p>
                    <RadioGroup name={question.questionGroup.alias} value={value} style={{ display: 'flex', flexDirection: 'row' }}>
                        {q.answers.map((v) => {
                            const aid = v.questionnaireAnswerID;
                            return (
                                <FormControlLabel
                                    key={`a${id}_${aid}`}
                                    value={`${aid}`}
                                    control={<Radio onClick={handleClick} color="primary" />}
                                    label={v.label}
                                    style={{ display: 'flex', minWidth: '6em' }}
                                />
                            );
                        })}
                    </RadioGroup>
                </FormLabel>
            </FormControl>
        </div>
    );
}
